var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEqualizer = function SvgEqualizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 6a6 6 0 0 0-5-5.91V0h-2v.09a6 6 0 0 0 0 11.82V48h2V11.91A6 6 0 0 0 48 6Zm-6 4a4 4 0 1 1 4-4 4 4 0 0 1-4 4ZM25 25.09V0h-2v25.09a6 6 0 0 0 0 11.82V48h2V36.91a6 6 0 0 0 0-11.82ZM24 35a4 4 0 1 1 4-4 4 4 0 0 1-4 4ZM7 .09V0H5v.09a6 6 0 0 0 0 11.82V48h2V11.91A6 6 0 0 0 7 .09ZM6 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4Z"
  })));
};
export default SvgEqualizer;